import Vue from 'vue'
import Vuex from 'vuex'

import system from '@/store/system'
import user from '@/store/user'
import dictionaries from "@/store/dictionaries"
import personalData from '@/store/personal-data/personalData'
import personalName from '@/store/personal-data/personalName'
import personalContact from '@/store/personal-data/personalContact'
import addressGar from '@/store/personal-data/addressGar'
import applicationsFilter from '@/store/applicationsFilter'
import vacancyFilter from '@/store/vacancyFilter'
import testResultFilter from '@/store/testResultFilter'

Vue.use(Vuex)

export default new Vuex.Store({
	strict: true,

	modules: {
    system,
		user,
		personalData,
		personalName,
		personalContact,
		addressGar,
		dictionaries,
		applicationsFilter,
    vacancyFilter,
    testResultFilter,
	}
})
